import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c6e0cb4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c6e0cb4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e0cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6e0cb4')) {
      api.createRecord('6c6e0cb4', component.options)
    } else {
      api.reload('6c6e0cb4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c6e0cb4&scoped=true", function () {
      api.rerender('6c6e0cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/tenant/index.vue"
export default component.exports